// extracted by mini-css-extract-plugin
export default {"list":"Menu_list__YsWk4","li":"Menu_li__ex8L9","linkName":"Menu_linkName__4BQY1","link":"Menu_link__UbbA9"};